(function () {
  if (window.__ptChains) return; window.__ptChains = 1;
  function emit(n, p) { try { if (window.traxEmit) window.traxEmit(n, p); } catch (e) {} }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.pt-cs [data-pt]');
    if (!a) return;
    var href = a.getAttribute('href') || '', c = a.closest('[data-ph]');
    if (/^(sms|tel):/.test(href) || /direct\.lc\.chat/.test(href)) return;
    emit('select_promotion', { promotion_id: 'chains-' + a.getAttribute('data-pt'), promotion_name: a.getAttribute('data-pn') || '',
      creative_slot: c ? c.getAttribute('data-ph') : '', link_url: href || location.pathname });
  }, true);
  var b = document.querySelector('.pt-cs');
  if (b && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) {
        var h = b.getAttribute('data-ph') || '';
        emit('view_promotion', { promotion_id: 'chains-view', promotion_name: h + '|shelf', creative_slot: h, link_url: location.pathname });
        io.disconnect(); break;
      }
    }, { threshold: 0.25 });
    io.observe(b);
  }
})();
